import React from 'react'
import { connect } from 'react-redux'
import { find } from 'lodash'

import BaseModal from 'components/Modals/BaseModal'
import { List } from 'ui'
import { closeModal } from 'store/actions/modals'
import { Format, durationInWords } from 'services/Dates'
import { getUserName } from 'services/Utilities'
import { t } from 'translations'

const ContactUserHistoryModal = ({ id, contactUsers, timeZone }) => {
  const { contactHistory = [], userId } = find(contactUsers, { _id: id })
  return (
    <BaseModal title={`manager.contactLists.CONTACT_USER_HISTORY_MODAL`} titleVar={{ name: getUserName(userId) }}>
      <List>
        {contactHistory.map(({ status, answer, author, createdAt, comment, callDuration }, index) => (
          <List.Item key={index}>
            <b className="mr-1">{Format(createdAt, { outFormat: 'humanDateTimeLog', isUTC: true, timeZone })}</b>
            <span className="mr-1">
              {t(`manager.contactLists.HISTORY.${answer}`)} / {t(`manager.contactLists.HISTORY.${status}`)}
            </span>
            <span className="mr-1">{t('manager.contactLists.HISTORY.BY')}</span>
            <b>{getUserName(author)}</b>
            {comment !== '-' ? <i className="ml-1">{comment}</i> : null}
            {typeof callDuration !== 'undefined' ? <i className="ml-1">{durationInWords(parseInt(callDuration), { fromSeconds: true })}</i> : null}
          </List.Item>
        ))}
      </List>
    </BaseModal>
  )
}

const mapStateToProps = ({ contactLists, settings }) => ({ contactUsers: contactLists.currentContactUsers, timeZone: settings.defaultTimeZone })
const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(ContactUserHistoryModal)
